import { PetLocation } from 'stores/types/Profiles';

export const getLocationsString = (location?: PetLocation) => `${location?.locality ? `${location.locality}, ` : ''}${location?.region ? `${location.region}, ` : ''}${location?.country || ''}`.trim();
